import { EXPERIENCE_DOMAIN_CONFIG, EXPERIENCE_HOST_DOMAINS } from '../constants';

type CustomTrackingConfig = {
  [key in EXPERIENCE_DOMAIN_CONFIG]: {
    companyIds: number[];
  };
};

export const customTrackingConfig: CustomTrackingConfig = {
  [EXPERIENCE_HOST_DOMAINS.localhost]: {
    companyIds: [1],
  },
  [EXPERIENCE_HOST_DOMAINS.mumbai]: {
    companyIds: [1],
  },
  [EXPERIENCE_HOST_DOMAINS.euDev]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.qa1]: {
    companyIds: [3024912],
  },
  [EXPERIENCE_HOST_DOMAINS.qa2]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.qa3]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.qa4]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.uatAM]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.uatEU]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.uatUS]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.stagingUS]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.stagingEU]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.au]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.eu]: {
    companyIds: [1002515],
  },
  [EXPERIENCE_HOST_DOMAINS.us]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.cn]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.au1]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.eu1]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.us1]: {
    companyIds: [],
  },
  [EXPERIENCE_HOST_DOMAINS.cn1]: {
    companyIds: [],
  },
};
